const cascaderInjectionKey = Symbol("ArcoCascader");
export { cascaderInjectionKey };
